import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGarbageBin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "garbage-bin" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 5.25,
			cy: 20.997,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "7.369 21.747 15 23.247 19.5 5.247 4.5 5.247 4.5 18.875"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.5.747H6a1.5,1.5,0,0,0-1.5,1.5v3H21A4.5,4.5,0,0,0,16.5.747Z"
		})
	]
});
export default SvgGarbageBin;
